import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function RiderOrder() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Rider Name",
      accessorKey: "RiderName",
    },
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
    },
    {
      header: "Date	",
      accessorKey: "Date",
    },
    {
      header: "Order Detail",
      accessorKey: "OrderDetail",
    },
    {
      header: "G.Total",
      accessorKey: "Total",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
    },
    {
      header: "Payment Status",
      accessorKey: "PaymentStatus",
    },
    {
      header: "Customer Detail",
      accessorKey: "CustomerDetail",
    },
    {
      header: "Order Status",
      accessorKey: "OrderStatus",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },
  ]);
  const [data] = useState([
      
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Rider Order List"}
      />
    </main>
  );
}

export default RiderOrder;
